<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Tvs",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {

            module_type: this.$route.params.module == 'pharmacy' ? 4 : 3,

            title: this.$route.params.module == 'pharmacy' ? "Pharmacy Tvs" : "Lab Tvs",
            items: [
               {
                  text: this.title,
                  active: true,
               },                   
            ],

            
            tvs: [],
            module: [],
            status: '',
            keyword: "",
            listing_length: 10,
            token: "",
            errors: {},
            button_title: "Save",
            pagination: {},
            isEdit: false,
            modal_title: "Add TV",
            module_request_name: this.$route.params.module == 'pharmacy' ? "pharmacy_id" : "lab_id",

            form: {
                id: null,
                name: '',
                username: '',
                password:'',
            },

            change_password: {
                    password: '',
                    password_confirmation: '',
            },
            
            
            active_page_url: null,
            loading: false,
         };
      },
      mounted() {

      },

      created() {
         this.fetchTvs();
      },

      methods: {


         fetchTvs(page_url = null){

            this.getToken();

            let url = "clinic/clinic/tvs?limit=" + this.listing_length +
                        "&status=" + this.status +
                        "&keyword=" + this.keyword +
                        "&type=" + this.module_type +
                        "&" + this.module_request_name + "=" + this.$route.params.id;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

         this.active_page_url = page_url;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.tvs = responseData.tvs.data;
               console.log(this.tvs);
               this.module = responseData.details;
               this.from = responseData.tvs.from;
               this.to = responseData.tvs.to;
               this.total = responseData.tvs.total;
               this.pagination = responseData.tvs.links;

            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));

         },
         
          getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 



         formatDate(dateString) {
			const date = new Date(dateString);

			const day = date.getDate();
			const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
			const year = date.getFullYear();

			const hours = date.getHours();
			const minutes = date.getMinutes();

			return `${day} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
		},
       
         showModal(modal) {
            this.$refs[modal].show();
         },
         hideModal(modal) {
            this.$refs[modal].hide();
         },
        
        editTV(tv) {
            this.modal_title = 'Edit TV';
            this.button_title = 'Update';
            this.isEdit = true;
            this.form.id = tv.id || '';
            this.form.name = tv.name || '';
            this.form.username = tv.username || '';
            this.form.password = ''; 

            // Open modal
            this.$refs['tv-modal'].show();
        },

        addTVModal() {
            this.modal_title = 'Add TV';
            this.button_title = 'Save';
            this.isEdit = false;
            this.clearForm();
            this.$refs['tv-modal'].show();
        },

        addTV(){

            this.getToken();

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            const url = this.isEdit
                ? 'clinic/clinic/updateTV'  
                : 'clinic/clinic/addTV';
                
            const payload = {
                name: this.form.name,
                username: this.form.username,
                type: this.module_type,
                [this.module_request_name]: this.$route.params.id,
                id  : this.form.id,
            };

            if (!this.isEdit) {
                payload.password = this.form.password;
            }
            this.loading = true;
            
            this.$axios
            .post(url, payload, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     this.$refs['tv-modal'].hide();
                     this.fetchTvs(); 
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.hideModal('tv-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

   

         },

        changeTvStatus(tv_id, status){

            this.getToken();
            let url = "clinic/clinic/updateTvStatus?tv_id=" + tv_id + "&status=" + status;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchTvs();
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
            this.fetchTvs();
        },

        tvDelete(tv) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to delete this tv account?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                     this.getToken();

                     const config = {
                        headers: {

                           "Accept": "application/json",
                           "Authorization": "Bearer " + this.token,
                        },
                     };

                     let url = "clinic/clinic/deleteTV";
                     let formData = new FormData();
                     formData.append("tv_id", tv.id);

                     this.$axios
                        .post(url, formData, config)
                        .then((response) => {
                           if (response.data.status) {
                              this.$swal("", response.data.message, "success");
                           } else {
                              this.$swal("", response.data.message, "error");
                           }
                           this.fetchTvs();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },

            changePassword(tv) {      
                this.change_password.id = tv.id;
                this.showModal("password-modal");
            },

            updatePassword() {
                this.getToken();           
                
                const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

                let url = "clinic/clinic/TvChangePassword";
                this.active_page_url = null;
                let formData = new FormData();
                formData.append("tv_id", this.change_password.id); 
                formData.append("password", this.change_password.password); 
                formData.append("password_confirmation", this.change_password.password_confirmation); 
                
                this.loading = true;
            
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.hideModal('password-modal');
                    this.fetchTvs(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            }, 


        clearForm() {
            this.form = {
            name: '',
            username: '',
            password: ''
            };
            this.errors = {};
            this.isEdit = false;

            this.change_password.password = "";
            this.change_password.password_confirmation = "";
        },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: $route.params.module == 'pharmacy' ? 'pharmacies' : 'labs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-12">
                        <b-media class="mb-4">
                           <b-media-body class="ms-3">
                              <h5 class="mt-1 mb-1">{{ module.name }}</h5>
                              <p>
                                 {{ module.address }}<br>
                                 {{ module.mobile }}
                              </p>
                           </b-media-body>
                        </b-media>
                     </div>
                  </div> 

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.tv-modal variant="primary" class="float-end" @click="addTVModal()">Add TV</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change = "fetchTvs()">
                                 <option value="1">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup = "fetchTvs()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change = "fetchTvs()">
                              <option value="">All</option>
                              <option value="1">Published</option>
                              <option value="2">Unpublished</option>
                           </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th width="10%">Name</th>   
                              <th width="15%">User Name</th>
                              <th width="10%">Status</th>
                              <th width="15%">Created On</th>
                              <th width="20%">Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(tvs.length)">
                           <tr v-for="tv in tvs" :key="tv.id">
                              <td>{{ tv.name }}</td>
                              <td>{{ tv.username }}</td>
                              <td>{{ tv.status == 1 ? 'Active' : 'Blocked' }}</td>
                              <td>{{ formatDate(tv.created_at) }}</td>
                              <td>
                                 <b-button variant="primary" v-b-modal.tv-modal class="btn btn-sm me-2 mb-2" @click="editTV(tv)">Edit</b-button> 
                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                 v-if="tv.status == 1" @click="changeTvStatus(tv.id, 2)" >Unpublish</b-button>
                                 <b-button variant="success" class="btn-sm me-2 mb-2"
                                 v-if="tv.status == 2" @click="changeTvStatus(tv.id, 1)" >Publish</b-button>

                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                  @click="tvDelete(tv)" >Delete</b-button>
                                 <b-button variant="danger" class="btn-sm mb-2 me-2" @click="changePassword(tv)"><i class='bx bxs-key'></i></b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No tvs found</td>
                           </tr>
                        </tbody>

                  </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(tvs.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchTvs(page.url + '&limit=' + listing_length + '&keyword=' + keyword + '&status=' + status + '&' + module_request_name + '=' + $route.params.id + '&type=' + module_type)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                 
                <b-modal ref="tv-modal" id="tv-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                    <b-form @submit.prevent="addTV">
                        <div class="row">


                        <!--  Name -->
                        <b-col md="12" class="form-group">
                            <label class="control-label"> Name <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="form.name" :class="{ 'is-invalid': errors.name }" />
                            <div class="invalid-feedback" v-if="errors.name">
                            {{ errors.name[0] }}
                            </div>
                        </b-col>

                        <!-- Username -->
                        <b-col md="12" class="form-group">
                            <label class="control-label">Username <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="form.username" :class="{ 'is-invalid': errors.username }" />
                            <div class="invalid-feedback" v-if="errors.username">
                            {{ errors.username[0] }}
                            </div>
                         </b-col>

                       
                        <!-- Password -->
                         <b-col md="12" class="form-group" v-if="!this.isEdit">
                            <label class="control-label">Password <span class="text-danger">*</span></label>
                            <input type="password" class="form-control" v-model="form.password" :class="{ 'is-invalid': errors.password }" />
                            <div class="invalid-feedback" v-if="errors.password">
                            {{ errors.password[0] }}
                            </div>
                         </b-col>
                        </div>

                        <!-- Buttons -->
                        <b-col md="12">
                           <div class="page-loader" v-if="!loading">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button variant="light" @click="hideModal('tv-modal')">Close</b-button>
                           </div>
                           <div class="page-loader" v-else>
                              <img src="@/assets/images/preloaderspin.gif"/>
                           </div>
                        </b-col>
                    </b-form>
                </b-modal>

               <!----- update password modal starts ---->
                    <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
                        <b-form @submit.prevent="updatePassword()">
                            <b-row>  
                            <b-col lg="12" class="form-group">
                                <label class="control-label">New Password<span class="text-danger">*</span></label>
                                <b-form-input type="password" v-model="change_password.password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                                <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>  

                            <b-col lg="12" class="form-group">
                                <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                                <b-form-input type="password" v-model="change_password.password_confirmation"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                                <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>    
                            
                            <b-col lg="12">
                               <div class="page-loader" v-if="!loading">
                                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
                               </div>
                               <div class="page-loader" v-else>
                                  <img src="@/assets/images/preloaderspin.gif"/>
                               </div>
                            </b-col>
                            </b-row>
                        </b-form>
                    </b-modal>
                  <!----- update password modal ends ---->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
